import {
  defineLayoutModule,
  type ViewLayoutModuleContext,
  type ViewLayoutModuleMode
} from '@databases/view-layout-modules';
import { z } from 'zod';

import { TABLE_V2_LAYOUT_ID } from './layout-id.js';

export { TABLE_V2_LAYOUT_ID } from './layout-id.js';

export type CreateTableV2LayoutModuleOptions = {
  /**
   * Controls durable writes and, through the registry, switcher eligibility.
   * The caller must perform experiment checks without firing exposure.
   */
  getMode: (context: ViewLayoutModuleContext) => ViewLayoutModuleMode;
};

/**
 * Creates the registered Table V2 layout module.
 *
 * Phase 0 has no durable layout properties. Future properties must add their
 * defaults to this schema so the module remains backward-compatible. Switcher
 * availability is derived from `getMode`; the module does not duplicate that
 * policy with an `isAvailable` callback.
 */
export const createTableV2LayoutModule = ({
  getMode
}: CreateTableV2LayoutModuleOptions) =>
  defineLayoutModule({
    id: TABLE_V2_LAYOUT_ID,
    schema: z.object({}),
    getMode,
    layoutSwitcher: {}
  });
